import { Button, Input, message } from 'antd'
import React from 'react'
import { View } from 'styles/reactnative'
import API from '../../../../../utils/api'
import { useToken } from '../../../../hooks'

const MemoInput = ({ data, type, mutate = () => {} }: any) => {
	const { data: token } = useToken()
	const [memo, setMemo] = React.useState(data?.memo)

	const saveMemo = () => {
		API.post('/admin/user/cash/memo', token + '', {
			type,
			id: data?.id,
			memo,
		})
			.then(res => {
				if (res.result.success) {
					message.success('성공')
					mutate()
				} else {
					message.error(res?.result?.message || '실패')
				}
			})
			.catch(err => {
				message.error('실패:' + err.message)
			})
	}

	return (
		<View style={{ width: '100%', flexDirection: 'row' }}>
			<Input
				defaultValue={data?.memo}
				value={memo}
				onChange={e => {
					setMemo(e.target.value)
				}}
				size="small"
			/>
			<Button
				size="small"
				type="primary"
				style={{ marginLeft: 5 }}
				onClick={saveMemo}>
				저장
			</Button>
		</View>
	)
}

export default React.memo(MemoInput)
